import { useTranslation } from 'react-i18next'
import { NavLink, useNavigate, useSearchParams } from 'react-router-dom'
import { Breadcrumbs, Container, Link, Typography } from '@mui/material'
import PageHeader from '../components/PageHeader'
import AuroraInstallation from '../components/installation/AuroraInstallation'
import { Aurora, Project } from '../types'

export default function InstallAuroraPage() {
  const { t } = useTranslation('installation')

  const navigate = useNavigate()

  const [searchParams, setSearchParams] = useSearchParams()

  const stepQuery = searchParams.get('step')
  const step = stepQuery !== null ? stepQuery : undefined

  const assetGroupIdQuery = searchParams.get('assetGroupId')
  const assetGroupId = assetGroupIdQuery !== null ? assetGroupIdQuery : undefined

  const projectIdQuery = searchParams.get('projectId')
  const projectId = projectIdQuery !== null ? parseInt(projectIdQuery) : undefined

  const auroraIdQuery = searchParams.get('auroraId')
  const auroraId = auroraIdQuery !== null ? auroraIdQuery : undefined

  const levelIdQuery = searchParams.get('levelId')
  const levelId = levelIdQuery !== null ? parseInt(levelIdQuery) : undefined

  const liftIdQuery = searchParams.get('liftId')
  const liftId = liftIdQuery !== null ? parseInt(liftIdQuery) : undefined

  const skipSelectProjectQuery = searchParams.get('skipSelectProject')
  const skipSelectProject = projectId !== undefined && skipSelectProjectQuery === 'true'

  const skipAuroraSetupQuery = searchParams.get('skipAuroraSetup')
  const skipAuroraSetup = auroraId !== undefined && skipAuroraSetupQuery === 'true'

  const handleProjectChange = (project: Project | null) => {
    const newSearchParams = new URLSearchParams(searchParams)

    if (project !== null) {
      newSearchParams.set('projectId', project.id.toString())
    } else {
      newSearchParams.delete('projectId')
    }

    setSearchParams(newSearchParams, {
      replace: true
    })
  }

  const handleAuroraChange = (aurora: Aurora | null) => {
    const newSearchParams = new URLSearchParams(searchParams)

    if (aurora !== null) {
      newSearchParams.set('auroraId', aurora.id)
    } else {
      newSearchParams.delete('auroraId')
    }

    setSearchParams(newSearchParams, {
      replace: true
    })
  }

  const handleStepChange = (step: string) => {
    const newSearchParams = new URLSearchParams(searchParams)

    newSearchParams.set('step', step)

    setSearchParams(newSearchParams, {
      replace: true
    })
  }

  const handleCancel = () => {
    navigate('/install')
  }

  return (
    <Container maxWidth={false}>
      <PageHeader
        title={t('installAurora')}
        breadcrumbs={
          <Breadcrumbs>
            <Link component={NavLink} to="/">
              {t('frontpage')}
            </Link>

            <Link component={NavLink} to="/install">
              {t('installation')}
            </Link>

            <Typography>{t('aurora')}</Typography>
          </Breadcrumbs>
        }
      />

      <AuroraInstallation
        step={step}
        assetGroupId={assetGroupId}
        projectId={projectId}
        auroraId={auroraId}
        levelId={levelId}
        liftId={liftId}
        skipSelectProject={skipSelectProject}
        skipAuroraSetup={skipAuroraSetup}
        onProjectChange={handleProjectChange}
        onAuroraChange={handleAuroraChange}
        onStepChange={handleStepChange}
        onCancel={handleCancel}
      />
    </Container>
  )
}
